<!-- Aside -->
<aside class="aside">
  <div class="aside-header">
    <img
      *ngIf="collapsed"
      src="/assets/icons/logo1.svg"
      alt="Logo"
      class="aside-logo"
      @fadeIn
      width="93" />
    <button class="btn-menu-minimize" (click)="toggleCollapse()" type="button">
      <span class="svg-icon">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_39_1232)">
            <path d="M0 3H24V5H0V3Z" fill="currentColor" />
            <path d="M8 11H24V13H8V11Z" fill="currentColor" />
            <path d="M14 19H24V21H14V19Z" fill="currentColor" />
          </g>
          <defs>
            <clipPath id="clip0_39_1232">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="matrix(-1 0 0 1 24 0)" />
            </clipPath>
          </defs>
        </svg>
      </span>
    </button>
  </div>
  <div class="aside-content">
    <ul>
      <li>
        <a
          routerLink="/dashboard"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">
          <span class="svg-icon">
            <svg
              width="28"
              height="30"
              viewBox="0 0 28 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M25.3332 27.75V24.9167C25.3332 23.4138 24.7361 21.9724 23.6734 20.9097C22.6107 19.847 21.1694 19.25 19.6665 19.25H8.33317C6.83028 19.25 5.38894 19.847 4.32623 20.9097C3.26353 21.9724 2.6665 23.4138 2.6665 24.9167V27.75M19.6665 7.91667C19.6665 11.0463 17.1295 13.5833 13.9998 13.5833C10.8702 13.5833 8.33317 11.0463 8.33317 7.91667C8.33317 4.78705 10.8702 2.25 13.9998 2.25C17.1295 2.25 19.6665 4.78705 19.6665 7.91667Z"
                stroke="currentColor"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
          <span *ngIf="collapsed" @fadeIn>
            {{ 'SIDE_MENU.PROFILE_INFO' | translate }}
          </span>
        </a>
      </li>
      @if (authService.status()) {
        <li>
          <a routerLink="purchase-orders" routerLinkActive="active">
            <span class="svg-icon">
              <svg
                width="37"
                height="36"
                viewBox="0 0 37 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1.5415 1.5415H7.70817L11.8398 22.1844C11.9808 22.8942 12.3669 23.5318 12.9306 23.9855C13.4943 24.4393 14.1997 24.6804 14.9232 24.6665H29.9082C30.6317 24.6804 31.337 24.4393 31.9007 23.9855C32.4644 23.5318 32.8505 22.8942 32.9915 22.1844L35.4582 9.24984H9.24984M15.4165 32.3748C15.4165 33.2263 14.7263 33.9165 13.8748 33.9165C13.0234 33.9165 12.3332 33.2263 12.3332 32.3748C12.3332 31.5234 13.0234 30.8332 13.8748 30.8332C14.7263 30.8332 15.4165 31.5234 15.4165 32.3748ZM32.3748 32.3748C32.3748 33.2263 31.6846 33.9165 30.8332 33.9165C29.9817 33.9165 29.2915 33.2263 29.2915 32.3748C29.2915 31.5234 29.9817 30.8332 30.8332 30.8332C31.6846 30.8332 32.3748 31.5234 32.3748 32.3748Z"
                  stroke="currentColor"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            <span *ngIf="collapsed" @fadeIn>
              {{ 'SIDE_MENU.ORDERS' | translate }}
            </span>
          </a>
        </li>
        <!-- <li>
          <a routerLink="notifications" routerLinkActive="active">
            <span class="svg-icon">
              <svg
                width="30"
                height="34"
                viewBox="0 0 30 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.4508 29.7502C17.2018 30.1795 16.8443 30.5359 16.4142 30.7837C15.984 31.0314 15.4964 31.1618 15 31.1618C14.5036 31.1618 14.016 31.0314 13.5858 30.7837C13.1557 30.5359 12.7982 30.1795 12.5492 29.7502M23.5 11.3335C23.5 9.07916 22.6045 6.91715 21.0104 5.32309C19.4163 3.72903 17.2543 2.8335 15 2.8335C12.7457 2.8335 10.5837 3.72903 8.98959 5.32309C7.39553 6.91715 6.5 9.07916 6.5 11.3335C6.5 21.2502 2.25 24.0835 2.25 24.0835H27.75C27.75 24.0835 23.5 21.2502 23.5 11.3335Z"
                  stroke="currentColor"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            <span *ngIf="collapsed" @fadeIn>
              {{ 'SIDE_MENU.NOTIFICATIONS' | translate }}
            </span>
          </a>
        </li> -->
      }
      <li>
        <button (click)="logout()" class="w-100">
          <span class="svg-icon">
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.75 27.75H5.08333C4.33189 27.75 3.61122 27.4515 3.07986 26.9201C2.54851 26.3888 2.25 25.6681 2.25 24.9167V5.08333C2.25 4.33189 2.54851 3.61122 3.07986 3.07986C3.61122 2.54851 4.33189 2.25 5.08333 2.25H10.75M20.6667 22.0833L27.75 15M27.75 15L20.6667 7.91667M27.75 15H10.75"
                stroke="currentColor"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
          <span *ngIf="collapsed" @fadeIn>
            {{ 'SIDE_MENU.LOG_OUT' | translate }}
          </span>
        </button>
      </li>
    </ul>
  </div>
</aside>
